import { useCallback, useEffect } from 'react';
import { MESSAGE_TYPES, ReceiveMessageType } from 'src/@types/message';
import useWebViewCommunication from 'src/hooks/useWebViewCommunication';
import { useStores } from 'src/models';
import { settingsApi } from 'src/services';

function AppMessageListener() {
  const { authStore } = useStores();
  // handle message from RN
  const handleRNMessage = useCallback((message: ReceiveMessageType) => {
    // server message ignore
    if ('resultCode' in message) {
      return;
    }

    switch (message.type) {
      case MESSAGE_TYPES.DEVICE_TOKEN: {
        const token = message.payload.deviceToken;
        settingsApi.saveDeviceToken(token);
        break;
      }
    }
  }, []);

  const { sendMessage } = useWebViewCommunication(handleRNMessage);

  useEffect(() => {
    if (authStore.user) {
      if (!authStore.isSaved) {
        sendMessage({ type: MESSAGE_TYPES.DEVICE_TOKEN });
        authStore.setProp('isSaved', true);
      }
    }
  }, [sendMessage]);

  return null;
}

export default AppMessageListener;
